module.exports = __webpack_public_path__ + "img/part5-icon2.ba444437.png";